import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router';
import Project1 from './Project1';
import Project2 from './Project2';
import Project3 from './Project3';
import Project4 from './Project4';

export default () => {
  const { id } = useParams();
  useEffect(() => {
    document.title = '陕西奕诚生物科技有限公司 - 公司项目情况';
  });
  return (
    <div id="projects">
      <div className="project-links row">
        <hr className="left" />
        <Link to="/projects/1" className={id === '1' ? "active" : ""} id="project-link-1">药用植物及经济作物新型苗孵化基地及推广种植</Link>
        <Link to="/projects/2" className={id === '2' ? "active" : ""} id="project-link-2">镇安秦岭山区5000亩树莓基地建设</Link>
        <Link to="/projects/3" className={id === '3' ? "active" : ""} id="project-link-3">商洛市镇安县1000亩七叶树基地建设</Link>
        <Link to="/projects/4" className={id === '4' ? "active" : ""} id="project-link-4">镇安县板栗种植及深加工产业化</Link>
        <hr className="right" />
      </div>
      {id === '1' && <Project1 />}
      {id === '2' && <Project2 />}
      {id === '3' && <Project3 />}
      {id === '4' && <Project4 />}
    </div>
  )
}